/** A Date used by a date picker represents calendar fields in the browser's locale. */
export function swedishToday(now = new Date()): Date {
  const parts = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Stockholm',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const field = (name: string) =>
    Number(parts.find((p) => p.type === name)?.value);
  return new Date(field('year'), field('month') - 1, field('day'));
}
